import React, { createContext } from 'react'
import './sandbox.scss'
import { PageHeader } from '../../components/page-header/page-header'

function Sandbox() {
    return <PageHeader title="Sandbox" />
}

export default Sandbox
